import { MONTHS } from '../../../constants';
import { Utils } from '../../../utils';

import type { TCalendarValue } from '@smiles/smiles-react-design-system/dist/components/V2/Calendar/types';
import type { AntecedenceTime, ISearchState, ItineraryData } from '../../../types';

export const formatCalendarValues = ({ pickup, dropoff }: ItineraryData) => {
  let output: TCalendarValue = {};

  if (pickup) {
    output.start = new Date(`${pickup.split('T')[0]}T00:00:00`);
  }

  if (dropoff) {
    output.end = new Date(`${dropoff.split('T')[0]}T00:00:00`);
  }

  return output;
};

const isLastDay = (date: Date) => {
  return new Date(date.getTime() + 86400000).getDate() === 1;
};

export const autoChangeDropoffCalendarMonth = (calendarRef: React.RefObject<HTMLDivElement>, pickup: string) => {
  const calendar = calendarRef.current as HTMLDivElement;
  const pickupDate = new Date(pickup);
  const pickupMonth = pickupDate.getMonth();
  const pickupYear = pickupDate.getFullYear();

  const calendarHeader = calendar.querySelector('.c-calendar__header') as HTMLDivElement;
  const [previous, next] = calendarHeader.querySelectorAll<HTMLButtonElement>('.c-button');
  const [month, year] = (calendarHeader.querySelector('.c-calendar__headerDetails') as HTMLDivElement).childNodes;
  const calendarLabelIndex = MONTHS.indexOf(month.textContent as string);

  // check if pickup year is after current year
  if (pickupYear > +String(year.textContent)) {
    let index = calendarLabelIndex;

    while (index <= 11) {
      setTimeout(() => {
        next.click();
      }, 1);

      index += 1;
    }

    for (let monthIndex = 0; monthIndex < pickupMonth; monthIndex += 1) {
      setTimeout(() => {
        next.click();
      }, 1);
    }
  } else if (pickupYear < +String(year.textContent)) {
    // if the user decides to go back to the current year
    let index = calendarLabelIndex;

    while (index >= 0) {
      setTimeout(() => {
        previous.click();
      }, 1);

      index -= 1;
    }

    for (let monthIndex = pickupMonth; monthIndex > 0; monthIndex -= 1) {
      setTimeout(() => {
        previous.click();
      }, 1);
    }
  }

  if (calendarLabelIndex < pickupMonth && pickupYear === +String(year.textContent)) {
    // press next until the month matches
    let index = calendarLabelIndex;

    while (index < pickupMonth) {
      setTimeout(() => {
        next.click();
      }, 1);

      index += 1;
    }
  } else if (calendarLabelIndex > pickupMonth && pickupYear === +String(year.textContent)) {
    // press previous until the month matches
    let index = calendarLabelIndex;

    while (index > pickupMonth) {
      setTimeout(() => {
        previous.click();
      }, 1);

      index -= 1;
    }
  }

  // Change to next month if selected date is last day from month
  if (isLastDay(pickupDate)) {
    next.click();
  }
};

export const disableDatesByAntecedence = (
  location: ISearchState['location'],
  antecedenceTime: AntecedenceTime,
): Date[] => {
  const today = new Date();

  if (location.pickup) {
    const time = {
      start: `${Utils.format.addLeadingZero(today.getHours())}:${Utils.format.addLeadingZero(today.getMinutes())}:00`,
      end: '23:59:00',
    };
    const isInternational = Utils.generics.isInternationalAgency(location.pickup);
    const antecedence = Utils.generics.getAntecedenceByInternationality(antecedenceTime, isInternational);
    const timeArray = Utils.time.generateTimeArray(time.start, time.end);
    const filteredTimeArray = timeArray.filter((currentTime) =>
      Utils.time.filterTimeByAntecedenceHours(currentTime, antecedence, new Date()),
    );

    if (filteredTimeArray.length === 0) {
      return [new Date()];
    }
  }

  return [];
};
